import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import { PrimaryLink } from "../ui/Buttons";
import CallButton from "../ui/CallButton";
import DirectionsButton from "../ui/DirectionsButton";
import BusinessHours from "../ui/BusinessHours";
import ReviewSection from "../ui/ReviewSection";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import { Link } from "react-router-dom";
import Smog from "../../assets/smogT.png";

const SmogEmissions = () => {
  return (
    <>
      <SeoHead
        title="Smog Check & Emissions Testing in Temecula | Advanced Automotive Smog"
        description="State smog check and emissions testing in Temecula, plus diagnostics and repair when a vehicle doesn't pass. Certified testing for all makes and models."
        path="/services/smog-emissions-services"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Smog & Emissions Testing"
          path="/services/smog-emissions-services"
          description="State smog check and emissions testing in Temecula, plus diagnostics and repair when a vehicle doesn't pass."
          serviceType="Smog and emissions testing"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image first on mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Smog}
                alt="Smog & Emissions Testing"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Emissions
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Smog & Emissions Testing
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Stay compliant with state regulations and keep your vehicle running
              efficiently with our certified Smog & Emissions testing service.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Smog & Emissions Testing?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Smog testing ensures your vehicle meets environmental standards.
              Failing smog may indicate issues with your exhaust or engine systems.
              <br />
              <br />
              We provide full emissions inspection, diagnostics for failed tests,
              and the repairs needed to get your vehicle compliant and road-ready.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                State-certified smog & emissions testing
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>
                  <Link to="/check-engine-light" className="text-teal-600 hover:underline">
                    Diagnostics
                  </Link>{" "}
                  &amp; repairs for failed smog tests
                </span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Fast and efficient service to get you back on the road
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps improve emissions performance and fuel efficiency
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Trusted, experienced technicians
              </li>
            </ul>

            {/* Clean Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>

        </div>

        <div className="mt-14 space-y-10 border-t border-slate-200 pt-12">
          <BusinessHours tone="light" />
          <ReviewSection tone="light" />
          <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:justify-center">
            <CallButton className="px-8 py-3 text-base" />
            <DirectionsButton className="px-8 py-3 text-base" />
          </div>
        </div>
    </ServicePageShell>
    </>
  );
};

export default SmogEmissions;

